import { render } from "./HomeIndex_vi.vue?vue&type=template&id=6ada5f2f&scoped=true&ts=true"
import script from "./HomeIndex_vi.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeIndex_vi.vue?vue&type=script&setup=true&lang=ts"

import "./HomeIndex_vi.vue?vue&type=style&index=0&id=6ada5f2f&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ada5f2f"],['__file',"src/components/home/HomeIndex_vi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ada5f2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ada5f2f', __exports__)) {
    console.log('reload')
    api.reload('6ada5f2f', __exports__)
  }
  
  module.hot.accept("./HomeIndex_vi.vue?vue&type=template&id=6ada5f2f&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6ada5f2f', render)
  })

}


export default __exports__